import React, { useCallback } from 'react'
import { Dropdown } from '../dropdown'

import { ReasonFormData } from '../../models/classes/ApplicationStep1.class'
import { OwnershipReasonEnum } from '../../models/enum/ownership-reason.enum'
import { reasonDropdown } from '../../utils/shared-dropdown'
import { ReasonEnum } from '../../models/enum/reason.enum'

interface ReasonDropdownProps{
  reasonValues:ReasonFormData,
  reasonSetFormValue: React.Dispatch<React.SetStateAction<any>>;
}

function ReasonDropdown({...props}:ReasonDropdownProps) {
  const handleSelectedDropdown = useCallback((value: any) => {
    if(value === ReasonEnum.financial_circumstances_reason_value){
      props.reasonSetFormValue({ reason: value.toString(), change_ownership_reason: OwnershipReasonEnum.financial_difficulties })
    }
    else if(value === ReasonEnum.marital_status_reason_value){
      props.reasonSetFormValue({ reason: value.toString(), change_ownership_reason: '', date_of_marriage: '' })
    } 
    else if(value === ReasonEnum.demise_current_owner_reason_value){
      props.reasonSetFormValue({ reason: value.toString(), change_ownership_reason: OwnershipReasonEnum.demise_of_current_owner })
    } 
    else if(value === ReasonEnum.health_reasons_reason_value){
      props.reasonSetFormValue({ reason: value.toString(), change_ownership_reason: OwnershipReasonEnum.medical })
    } 
    else if(value === ReasonEnum.loss_of_citizenship_reason_value){
      props.reasonSetFormValue({ reason: value.toString(), change_ownership_reason: OwnershipReasonEnum.renunciation })
    } 
    else if(value === ReasonEnum.owner_moving_out_reason_value){
      props.reasonSetFormValue({ reason: value.toString(), change_ownership_reason: '', date_of_marriage: '' })
    } 
    else{
      props.reasonSetFormValue({ reason: value.toString(), change_ownership_reason: '' })
    }

    //Reset
    if(value !== ReasonEnum.marital_status_reason_value){
      props.reasonSetFormValue({ have_final_judgement: '', final_judgement_date: ''})
    }
    if(value !== ReasonEnum.financial_circumstances_reason_value){
      props.reasonSetFormValue({ has_outstanding_loan: '', outstanding_loan_amount: ''})
    }
  },[props]);
  
  return (
    <Dropdown style={{ marginTop: 32 }} variant={"small"} selectedDropdown={props.reasonValues.reason} setSelectedDropdown={handleSelectedDropdown} items={reasonDropdown} placeholder='Please indicate a reason' label='Reason' required={true}/>
  )
}

export default ReasonDropdown